import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['No sé qué publicar sin sonar repetitivo.', 'Me da pena vender.', 'Siento que necesito más seguidores para ganar.', 'Tengo días que publico y días que desaparezco.', 'Me siento ocupado… pero no avanzo.'];
  return <Section className="bg-[#0a0a0a]" data-id="element-259">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-260">
        <div data-id="element-261">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white leading-tight" data-id="element-262">
            Si te identificas con cualquiera de estas…
          </h2>
          <ul className="space-y-5" data-id="element-263">
            {pains.map((pain, index) => <li key={index} className="flex items-start gap-3 text-gray-300 text-lg" data-id="element-264">
                <XCircle className="text-red-400/80 mt-1 shrink-0" size={20} data-id="element-265" />
                <span data-id="element-266">{pain}</span>
              </li>)}
          </ul>
        </div>
        <div className="luxury-border p-8 md:p-10 relative" data-id="element-267">
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#14b8a6] opacity-[0.06] rounded-full blur-2xl" data-id="element-268" />
          <p className="text-2xl font-medium text-white mb-4" data-id="element-269">
            …entonces este ebook no te va a motivar.
          </p>
          <p className="text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#14b8a6] to-[#2dd4bf] mb-6" data-id="element-270">
            Te va a ordenar.
          </p>
          <div className="luxury-divider my-6" data-id="element-271" />
          <p className="text-gray-400 leading-relaxed" data-id="element-272">
            Porque la mayoría está intentando monetizar redes sociales como si
            fuera un concurso de popularidad. Y no lo es.
            <br data-id="element-273" />
            <br data-id="element-274" />
            <span className="text-white font-bold" data-id="element-275">
              Es un sistema de conversión.
            </span>
          </p>
        </div>
      </div>

      <div className="mt-12 max-w-3xl mx-auto glass-card p-8 text-center border-l-4 border-[#14b8a6]" data-id="element-276">
        <p className="text-lg text-gray-300 leading-relaxed" data-id="element-277">
          Publicabas contenido suelto. Informaba. Entretenía. Pero no tenía una{' '}
          <span className="text-white font-bold" data-id="element-278">
            ruta de monetización clara
          </span>
          , ni guiones diseñados para la acción.
          <br data-id="element-279" />
          <span className="block mt-4 text-xl font-bold text-white" data-id="element-280">
            Mucho movimiento, cero ingresos.
          </span>
        </p>
      </div>
    </Section>;
}